import VueRouter from 'vue-router';
import { magic } from '@gig/magic-sdk';
import { modalService, ModalSize } from '@gig/magic-common';
import { isPhoneVerificationRequired } from '../../phone-verification/phone-verification.service';
import { PhoneVerification } from '@gig/magic-corex';

export function initPhoneVerificationGuard(router: VueRouter) {
    router.beforeEach(async (to, from, next) => {
        if (!magic.session.isCreated()) {
            return next();
        }

        try {
            const phoneVerificationRequired =
                await isPhoneVerificationRequired();

            if (phoneVerificationRequired) {
                const vm = new PhoneVerification().$mount();

                const modalRef = modalService.open(
                    'phone-verification.title',
                    vm.$el,
                    {
                        size: ModalSize.DEFAULT,
                        dismissible: false,
                    },
                );

                vm.$on('close', () => {
                    modalService.close(modalRef);
                });

                return next(false);
            }
        } catch (error) {
            console.error('Error checking phone verification status:', error);
        }

        next();
    });
}
